module.exports = __webpack_public_path__ + "static/media/19ESCAP30.3732f4ec.jpg";